import React from "react";
import { InfoWindow } from "react-google-maps";

export class InfoCard extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { marker, index } = this.props;
        console.log(marker);

        return (
            <InfoWindow onCloseClick={() => this.props.handleOpenMarker(index)}>
                <div style={{ padding: "4px" }}>
                    <div style={{ display: "flex", justifyItems: "center", alignItems: "center", width: "100%" }}>
                        <h6 style={{ margin: 0 }}>{marker.name}</h6>
                    </div>
                    <p style={{ whiteSpace: "pre-wrap" }}>
                        {marker.description}
                    </p>
                </div>
            </InfoWindow>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HomeVisits/components/InfoCard.jsx